<template>
	<div>
		<button class="is-btn" @click="goWx">立即观看</button>
	</div>
</template>

<script>
export default {
  name: 'goMini',
  components: {},
  data() {
    return {
      wxHref: 'weixin://dl/business/?t=T8H1LcpXgEt'
    }
  },
  mounted() {
    
  },
  methods: {
    goWx() {
      location.href = this.wxHref
    }
  },
}
</script>

<style lang="scss" scoped>
.is-btn{
  width: 80%;
  height: 44px;
  line-height: 44px;
  border-radius: 4px;
  margin: 10%;
  background: #df3d3e;
  color: white;
  font-size: 15px;
  animation: movebig 1.5s ease-in-out infinite;
}
@keyframes movebig{
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}

@-webkit-keyframes movebig{
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>
